import { createFieldSelectorHook } from 'src/lib/sweetState';

import { CustomerStore } from './CustomerStore';

export const useCurrentCustomer = createFieldSelectorHook(CustomerStore, 'currentCustomer');
